import { QueryKey } from '@web/shiftTasks/types/QueryKey';

export const getShiftTaskDetailsQueryKey = (id: number) => [QueryKey.SHIFT_TASKS, id] as const;
